import { Inject, Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { Store } from '@ngrx/store'
import { Observable } from 'rxjs'
import { ProjectDialogActions } from './action-types'
import { concatMap } from 'rxjs/operators'
import { CadastralAreaSearchActions } from '../../../../../domain/cadastral/components/cadastral-area-search/state/action-types'

@Injectable()
export class ProjectDialogEffects {

    setLv$: Observable<any>
    setArea$: Observable<any>

    constructor(@Inject(Actions) private actions$: Actions,
                @Inject(Store) private store: Store,
    ) {
        this.setArea$ = createEffect(() => this.actions$.pipe(
            ofType(ProjectDialogActions.setArea),
            concatMap((action) => {
                return [
                    ProjectDialogActions.setProjectArea({
                        area: action.area
                    }),
                    CadastralAreaSearchActions.setCadastralAreaSearchKatuze({
                        katuzeKod: action.area.katuzeKod,
                        katuzeNazev: null
                    }),
                    CadastralAreaSearchActions.updateFilterCriteria({
                        filterCriteriaFragment: {
                            searchText: action.area.katuzeNazev
                        }
                    })
                ]
            })
        ))

        this.setLv$ = createEffect(() => this.actions$.pipe(
            ofType(ProjectDialogActions.setLv),
            concatMap((action) => {
                return [
                    ProjectDialogActions.setProjectLv({
                        lv: action.lv
                    }),
                    CadastralAreaSearchActions.setCadastralAreaSearchKatuze({
                        katuzeKod: action.lv.katuzeKod,
                        katuzeNazev: null
                    }),
                    CadastralAreaSearchActions.updateFilterCriteria({
                        filterCriteriaFragment: {
                            searchText: action.lv.katuzeNazev
                        }
                    })
                ]
            })
        ))
    }
}